import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "../../hooks/useTranslation";
export function DoctorFinderBar({ searchQuery, onSearchChange, specializations, specializationFilter, onSpecializationChange, showSpecializationTabs, isMobile = false, hideBottomBorder = false, }) {
    const { t } = useTranslation("appointment");
    return (_jsxs(Box, { sx: {
            borderBottom: hideBottomBorder ? 0 : 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            flexShrink: 0,
            px: isMobile ? 1.5 : 2,
            py: isMobile ? 1 : 1.25,
        }, children: [_jsxs(Stack, { direction: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "center", justifyContent: "space-between", spacing: isMobile ? 1 : 1.5, children: [_jsx(Typography, { sx: { fontSize: 14, fontWeight: 700, flexShrink: 0 }, children: t("findYourDoctor", "Find your doctor") }), _jsx(TextField, { size: "small", value: searchQuery, onChange: (e) => onSearchChange(e.target.value), placeholder: t("searchDoctorByName", "Search doctor by name"), slotProps: {
                            input: {
                                startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchIcon, { sx: { fontSize: 18, color: "text.secondary" } }) })),
                            },
                        }, sx: {
                            width: isMobile ? "100%" : 280,
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "50px",
                                bgcolor: "background.paper",
                                fontSize: 13,
                            },
                            "& .MuiOutlinedInput-input": { py: "7px" },
                        } })] }), showSpecializationTabs && (_jsxs(Box, { className: "medos-hscroll", sx: {
                    display: "flex",
                    gap: 0.75,
                    overflowX: "auto",
                    mt: 1,
                    pb: 0.25,
                }, children: [_jsx(SpecTab, { label: t("all", "All"), active: specializationFilter === "all", onClick: () => onSpecializationChange("all") }), specializations.map((s) => (_jsx(SpecTab, { label: s, active: specializationFilter === s, onClick: () => onSpecializationChange(s) }, s)))] }))] }));
}
function SpecTab({ label, active, onClick, }) {
    return (_jsx(Box, { component: "button", type: "button", role: "tab", "aria-selected": active, onClick: onClick, sx: {
            flexShrink: 0,
            border: 1,
            borderColor: active ? "primary.main" : "divider",
            bgcolor: active ? "primary.main" : "background.paper",
            color: active ? "primary.contrastText" : "text.secondary",
            borderRadius: "50px",
            px: 1.5,
            py: "5px",
            fontSize: 12.5,
            fontWeight: active ? 600 : 500,
            whiteSpace: "nowrap",
            cursor: "pointer",
            transition: "all 0.15s",
            "&:hover": {
                borderColor: "primary.main",
                bgcolor: active ? "primary.main" : "action.hover",
            },
            "&:focus-visible": {
                outline: "2px solid",
                outlineColor: "primary.main",
                outlineOffset: 1,
            },
        }, children: label }));
}
